var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"two-line":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.item.title))]),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.item.description.value)}}),_c('v-card-actions',[_vm._l((_vm.slots),function(slot){return [_c('v-btn',{key:slot.key},[_vm._v(_vm._s(slot.label))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }